var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9987 9.91666C18.5635 9.91667 19.832 8.64814 19.832 7.08333C19.832 5.51853 18.5635 4.25 16.9987 4.25C15.4339 4.25 14.1654 5.51853 14.1654 7.08333C14.1654 8.64814 15.4339 9.91666 16.9987 9.91666Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9987 19.8333C18.5635 19.8333 19.832 18.5648 19.832 17C19.832 15.4352 18.5635 14.1667 16.9987 14.1667C15.4339 14.1667 14.1654 15.4352 14.1654 17C14.1654 18.5648 15.4339 19.8333 16.9987 19.8333Z",
    fill: "#696969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9987 29.75C18.5635 29.75 19.832 28.4815 19.832 26.9167C19.832 25.3519 18.5635 24.0833 16.9987 24.0833C15.4339 24.0833 14.1654 25.3519 14.1654 26.9167C14.1654 28.4815 15.4339 29.75 16.9987 29.75Z",
    fill: "#696969"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalOptions);
export default __webpack_public_path__ + "static/media/vertical-options.8290e7beed7dea66c4bb2339d8aac0cd.svg";
export { ForwardRef as ReactComponent };